var _rect, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 2,
    fill: "#2B1B57",
    fillOpacity: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14.5,
    x2: 40,
    y2: 14.5,
    stroke: "white",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 25.5,
    x2: 40,
    y2: 25.5,
    stroke: "white",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 36.5,
    x2: 40,
    y2: 36.5,
    stroke: "white",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.52754b31c98ba11dc27f0baee2ec61b5.svg";
export { ForwardRef as ReactComponent };